"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acquireFileFromDrive = acquireFileFromDrive;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _Constants = require("FileManagerCore/Constants");

var FileApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

function acquireFileFromDrive(file, folder) {
  return function (dispatch, getState, httpClient) {
    var fileData = {
      name: file.name,
      authorization: file.authorization
    };

    if (folder) {
      fileData.folder_id = folder.get('id');
    }

    dispatch({
      type: _ActionTypes.DOWNLOAD_FROM_DRIVE_ATTEMPTED,
      file: _immutable.default.Map(fileData),
      meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
        name: 'Manage Files',
        usageTrackerJsName: 'fileManagerManageFiles',
        action: 'upload-drive-attempt'
      })
    });
    return FileApi.downloadFromUrl(_immutable.default.Map(fileData), file.url, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_DRIVE_SUCCEEDED,
        file: data,
        meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
          name: 'Manage Files',
          usageTrackerJsName: 'fileManagerManageFiles',
          action: 'upload-drive-success'
        })
      });
    }).catch(function (data) {
      var message = _I18n.default.text('FileManagerCore.notifications.upload.error.message', {
        filename: data.name
      });

      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_DRIVE_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
            message: message
          },
          error: data
        }
      });
    });
  };
}